export enum BolEndpoint {
    INVENTORY = "inventory",
    ORDERS_ALL = "orders-all",
    ORDERS_NEW = "orders-new",
    OFFERS = "offers",
    RANKS = "ranks",
    SEARCH_TERMS = "search-terms",
    INVOICES = "invoices",
}
